<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="pt-2">
        <div class="card">
            <div class="card-header">
				Candidate
			</div>
            <div class="card-body">
                <div class="row">
                    <!-- <ul class="nav nav-pills nav-fill gap-2 p-1 small bg-primary rounded-2 shadow-sm" id="pillNav2"
                        role="tablist"
                        style="--bs-nav-link-color: var(--bs-white); --bs-nav-pills-link-active-color: var(--bs-primary); --bs-nav-pills-link-active-bg: var(--bs-white);">
                        <li class="nav-item" role="presentation">
                            <button type="button" class="nav-link rounded-2" (click)="setSelectType(1)"
                                [class.active]="Filter.ListType === 1" [value]="1">
                                <i class="bi bi-person-badge"></i> Candidate Initiate
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button type="button" class="nav-link rounded-2" (click)="setSelectType(2)"
                                [class.active]="Filter.ListType === 2" [value]="2">
                                <i class="bi bi-bootstrap-reboot"></i> Candidate Reinitiate / Reminder
                            </button>
                        </li>
                    </ul> -->
                    <div class="row">
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <button type="button" class="btn btn-outline-primary" (click)="setSelectType(1)"
                                style="width:100%" [class.active]="Filter.ListType === 1" [value]="1">
                                <i class="bi bi-person-badge"></i> Candidate Initiate
                            </button>
                            <button type="button" class="btn btn-outline-primary" (click)="setSelectType(2)"
                                [class.active]="Filter.ListType === 2" style="width:100%" [value]="2">
                                <i class="bi bi-bootstrap-reboot"></i> Candidate Reinitiate / Reminder
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row pt-2">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" [ngClass]="{'colHide': this.Filter.ListType == 1}"><input
                                        class="form-check-input" type="checkbox" id="IsApproveAll" name="IsApproveAll"
                                        (click)="ARCheck($event,0,true)"> Check</th>
                                <th class="border-1">Details</th>
                                <th>Branch Name</th>
                                <th>Joining Date</th>
                                <th>WorkingStatus</th>
                                <th>Status</th>
                                <!-- <th>Progress</th> -->
                                <th
                                    [ngClass]="{'colHide': !this.common.PageRight.IsEdit && !this.common.PageRight.IsView}">
                                    Action</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let element of EmployeeData; let i = index">
                                <td class="text-center" [ngClass]="{'colHide': this.Filter.ListType == 1}">
                                    <div style="width: 80px;"><input class="form-check-input" type="checkbox"
                                            id="IsApprove{{i}}" name="IsApprove{{i}}" (click)="ARCheck($event,i)"
                                            [(ngModel)]="element['IsARCheck']">
                                    </div>
                                </td>
                                <td style="width: 300px;" class="border-1">
                                    <div class="row" style="align-items: center;" style="align-items: center;width: 300px;">
                                        <div class="col-2">
                                            <img *ngIf="element['Photo'] != null && element['Photo'] != ''"
                                                (click)="common.FullImage('',{ProfileImage:common.PhotoLink(element['Photo']),Name:element['EmployeeName'],Code:element['EmpCode']} )"
                                                mat-card-image class="userImage"
                                                [src]="common.PhotoLink(element['Photo'])" />
                                            <div *ngIf="element['Photo'] == null || element['Photo'] == ''"
                                                (click)="common.FullImage('',{ProfileImage:common.PhotoLink(element['Photo']),Name:element['EmployeeName'],Code:element['EmpCode']} )"
                                                class="initial-image">
                                                <div class="image">
                                                    {{common.getInitial(element['EmployeeName'])}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-10">
                                            <span class="text-label">{{element['EmployeeName']}}</span><br />
                                            <span class="text-label-light">#{{element['EmpCode']}} <span
                                                    *ngIf="element['DesignationName'] != null && element['DesignationName'] != ''">[{{element['DesignationName']}}]</span></span><br />
                                        </div>
                                    </div>
                                </td>
                                <td style="width: 200px;"><div style="width: 200px;">{{element['BranchName']}}</div></td>
                                <td style="width: 100px;"><div style="width: 100px;">{{element['JoiningDate']}}</div></td>
                                <td>{{element['WorkingStatus']}}</td>
                                <td>{{element['Status']}}</td>
                                <!-- <td>
                                    <ngb-progressbar mode="determinate" [value]="60" style="border-radius: 5px;"
                                        *ngIf="i % 2==0 && i != 5" />
                                    <ngb-progressbar mode="determinate" class="progressworning" [value]="40"
                                        style="border-radius: 5px;" *ngIf="i % 2==1 && i != 5" />
                                    <ngb-progressbar mode="determinate" class="progresssuccess" [value]="100"
                                        style="border-radius: 5px;" *ngIf="i == 5" />
                                    <label style="float: inline-end; font-size: 10px; color: #585BD5;">{{i % 2==0 && i
                                        !=
                                        5?'60':i == 5?100:40}}%</label>

                                </td> -->
                                <td
                                    [ngClass]="{'colHide': !this.common.PageRight.IsEdit && !this.common.PageRight.IsView}">
                                    <div style="min-width:200px;width: auto;display: flex;">
                                        <button class="btn btn-primary btn-sm mx-1" type="button"
                                            style="width: 130px; height: 30px;" *ngIf="this.common.PageRight.IsEdit"
                                            [routerLink]="['/onboarding/candidateinitiation/preonboardingsetup/' + element['EmpMasterId']]"><i
                                                class="bi bi-person-raised-hand me-2"></i>{{this.Filter.ListType ==
                                            1?'Initiate':'ReInitiate'}}</button>
                                        <button class="btn btn-warning btn-sm mx-1" type="button"
                                            style="width: 130px; height: 30px;"
                                            *ngIf="this.common.PageRight.IsEdit && this.Filter.ListType == 2"
                                            (click)="ESS_SendReminderMailSend(element['EmpMasterId'])"><i
                                                class="bi bi-bootstrap-reboot me-2"></i>Reminder</button>
                                        <button class="btn btn-primary btn-sm mx-1" type="button"
                                            style="width: 130px; height: 30px;"
                                            *ngIf="this.common.PageRight.IsView && this.Filter.ListType == 2"
                                            [routerLink]="['/onboarding/candidateinitiation/detail/' + element['EmpMasterId'] + '/true']"><i
                                                class="bi bi-eye  me-2"></i>View</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-footer" *ngIf="this.Filter.ListType == 2 && EmployeeData.length > 0">
                <div class="row">
                    <div class="col">
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-success mx-1" [disabled]="isDisabled"
                            (click)="ESS_SendReminderMailSend('0')"><i class="bi bi-bootstrap-reboot"
                                *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Reminder':'Loading...'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>